<div class="row seach-filter-alert" *ngIf="showAlert">
  <div class="col-sm-1 picture">
    <img src="{{ pictureUrl }}" alt="" class="img-circle" />
  </div>
  <div class="col-sm-9 text">{{ filterName | translate : { userName: name } }}</div>
  <div *ngIf="closable" class="col-xs-1 col-sm-1 col-md-1 close" (click)="close()">
    <img src="../assets/img/icons/close.svg" alt="" />
  </div>
</div>
